module.exports = __webpack_public_path__ + "img/responsive hospitium-06.c9618381.jpg";